import classnames from "classnames";
import * as React from "react";

import styles from "./StripeElementPlaceholder.module.scss";

type Props = {
  loading: boolean;
  children: React.ReactNode;
};

export const StripeElementPlaceholder = ({ loading, children }: Props) => {
  return (
    <>
      <div
        className={classnames({
          [styles.hidden]: loading
        })}
      >
        {children}
      </div>
      {loading && <div className={styles.placeholder} />}
    </>
  );
};
